import styled from '@emotion/styled'

const Card = ({ title, imgIcon, info, infoTitle, learnMoreClick = () => {} }) => {
  return (
    <Style>
      <div className='card'>
        <div className='card-header'>
          <div className='card-header-title'>{title}</div>
          <div className='card-header-img'>
            <img alt='' src={imgIcon} />
          </div>
        </div>
        <div className='card-content'>
          <div className='card-content-title'>{infoTitle}</div>
          <div className='card-content-detail'>{info}</div>
          <div className='card-content-more' onClick={learnMoreClick}>
            LEARN MORE
          </div>
        </div>
      </div>
    </Style>
  )
}
const Style = styled.div`
  label: product-card;
  /* width: 290px; */
  border-radius: 5px;
  .card:hover {
    transform: scale(1.1) translateX(10px);
    transition: all 0.3s ease-in-out;
  }
  .card-header {
    border-radius: 5px 5px 0 0;
    padding: 10px 20px;
    background-color: #0e1b50;
    display: flex;
    justify-content: space-between;
    color: #ffffff;

    .card-header-title {
      font-weight: bold;
      font-size: 30px;
    }
    .card-header-img {
      padding: 0 10px 0 0;
      img {
        width: 66px;
        height: auto;
      }
    }
  }

  .card-content {
    background-color: #ffffff;
    min-height: 200px;
    box-shadow: 0px 3px 6px #00000029;
    padding: 20px;

    .card-content-title {
      color: #1564c0;
      font-weight: bold;
      font-size: 18px;
    }
    .card-content-detail {
      padding: 10px 0;
      word-break: break-word;
      font-size: 14px;
    }

    .card-content-more {
      color: #686868;
      text-decoration: underline;
      cursor: pointer;
      font-size: 12px;
    }
    .card-content-more:hover {
      color: #000000;
      transform: scale(1.1) translateX(10px);
      transition: all 0.3s ease-in-out;
    }
  }
`

export default Card
